<template>
    <div
        v-if="menuList.length > 0 && quickLaunchBox && displayStatus"
        v-on="!quickToggle && !['production'].includes(config.public.ENV) ? { mousedown: startDrag, touchstart: startDrag } : {}"
        :style="{ right: position.right + 'px', bottom: position.bottom + 'px' }"
        class="quickLaunchBox-v2"
        :class="[quickToggle ? 'vertical' : 'horizontal', { close: !quickLaunchBox }, { draging: isDragging }, { top: dashboardPosition.includes('top') }]">
        <button
            v-if="hasAllowedTypes"
            @click.stop="toggleQuickLaunch"
            type="button"
            class="btn-quick-center absolute -top-10 left-1/2 grid h-6 w-6 -translate-x-1/2 place-content-center rounded-full"
            :aria-label="quickToggle ? hideQuickLaunchLabel : showQuickLaunchLabel">
            <div class="grid transform" :class="quickToggle ? `rotate-${dashboardPosition.includes('top') ? '0' : '180'}` : `rotate-${dashboardPosition.includes('top') ? '180' : '0'}`">
                <Icon iconClass="icon-dropup text-[10px]"></Icon>
            </div>
        </button>
        <button
            @click="quickLaunchBox = false"
            type="button"
            class="btn-quick-box absolute -top-6 grid h-6 w-6 place-content-center rounded-full"
            :class="`-${dashboardPosition.includes('left') ? 'right' : 'left'}-2`"
            :aria-label="hideQuickLaunchLabel">
            <Icon iconClass="icon-close text-xs"></Icon>
        </button>
        <div v-if="quickToggle" class="mb-2 flex justify-center gap-4">
            <button
                type="button"
                v-if="!isBeginning"
                @click="goPrev"
                class="quick-toggle-nav quick-nav-prev absolute grid h-6 w-6 place-content-center rounded-full"
                aria-label="Previous quick shortcut">
                <Icon iconClass="icon-up text-xs"></Icon>
            </button>
            <button type="button" v-if="!isEnd" @click="goNext" class="quick-toggle-nav quick-nav-next absolute grid h-6 w-6 place-content-center rounded-full" aria-label="Next quick shortcut">
                <Icon iconClass="icon-down text-xs"></Icon>
            </button>
        </div>

        <div ref="swiperWrapperRef" class="overflow-hidden" :class="{ 'swiper-container-wrapper rounded-full px-1.5 sm:px-2': quickToggle }">
            <Swiper
                :key="!quickToggle ? 'vertical' : 'horizontal'"
                :modules="[Navigation, ...(quickToggle ? [] : [Autoplay])]"
                :slides-per-view="quickToggle ? 4 : 1"
                :direction="quickToggle ? 'vertical' : 'horizontal'"
                :autoplay="!quickToggle ? { delay: 2000, disableOnInteraction: false } : false"
                :speed="1000"
                :space-between="20"
                :grab-cursor="true"
                :loop="quickToggle ? false : true"
                class="mySwiper"
                :class="{ '!py-5': quickToggle }"
                @swiper="onSwiper"
                @slideChange="onSlideChange">
                <SwiperSlide v-for="m in filteredMenuList" :key="m.type">
                    <div class="list flex items-center justify-center">
                        <button
                            v-if="m.type === 'leaderboard'"
                            @click="!quickToggle ? (quickToggle = true) : handleLeaderboardClick()"
                            type="button"
                            class="listed"
                            :class="m.type"
                            :aria-label="m.message">
                            <img class="w-full" :src="`${config.public.STATIC_ROOT}img/icons/quick_${m.type}.webp`" :alt="m.message" />
                        </button>
                        <button
                            v-else-if="m.type === 'vip' && [1].includes(config.public?.TMPL_TYPE) && isMobile"
                            @click="!quickToggle ? (quickToggle = true) : handleVipClick()"
                            type="button"
                            class="listed"
                            :class="m.type"
                            :aria-label="m.message">
                            <img class="w-full" :src="`${config.public.STATIC_ROOT}img/icons/quick_${m.type}.webp`" :alt="m.message" />
                        </button>
                        <button
                            v-else-if="m.type === 'sign_in_task'"
                            @click="!quickToggle ? (quickToggle = true) : handleSignIntaskClick()"
                            type="button"
                            class="listed"
                            :class="m.type"
                            :aria-label="m.message">
                            <img class="w-full" :src="`${config.public.STATIC_ROOT}img/icons/quick_${m.type}.webp`" :alt="m.message" />
                        </button>
                        <button
                            v-else-if="m.type === 'campaign' && isAllowedMerchantOrTmplTypeMiniGame === true && campaignListReady && campaignList?.data?.length > 0"
                            @click="!quickToggle ? (quickToggle = true) : handleClick(m)"
                            type="button"
                            class="listed animate-event"
                            :class="m.type"
                            :aria-label="m.message">
                            <img class="w-full" :src="getMiniGameImageUrl(m.miniGameType)" :alt="m.message" />
                        </button>
                        <button v-else-if="m.type == 'predictor'" @click="navigateTo(localePath('/prediction/soccer'))" type="button" :aria-label="$t('predictor')" class="listed">
                            <video autoplay loop muted playsinline>
                                <source :src="`${config.public.STATIC_ROOT}img/prediction/soccer/${m.type}.webm`" type="video/webm" />
                            </video>
                        </button>
                        <button v-else @click="handleClick(m)" :aria-label="m.message" type="button" class="listed" :class="m.type">
                            <div v-if="m.type === 'lucky_spin' && isInHouseMerchant" class="relative">
                                <img class="absolute z-10 w-full" :src="`${config.public.STATIC_ROOT}img/icons/${m.type}_frame.webp`" :alt="`${m.type}_frame`" />
                                <img class="img_rotate_animation w-full" :src="`${config.public.STATIC_ROOT}img/icons/quick_${m.type}_new.webp?v=2`" :alt="`quick_${m.type}_new`" />
                            </div>
                            <img v-else class="w-full" :src="`${config.public.STATIC_ROOT}img/icons/quick_${m.type}.webp`" :alt="`quick_${m.type}`" />
                            <div v-if="m.type === 'angpow' && mainStore.angpau_isFixed" class="angpau_countdown">
                                {{
                                    mainStore.angpau_isStarted
                                        ? $t("claim_now")
                                        : `${dashboardStore.angpau_hours >= 0 ? dashboardStore.angpau_hours : 0}H:${dashboardStore.angpau_minutes >= 0 ? dashboardStore.angpau_minutes : 0}M:${dashboardStore.angpau_seconds >= 0 ? dashboardStore.angpau_seconds : 0}S`
                                }}
                            </div>
                        </button>
                    </div>
                </SwiperSlide>
                <SwiperSlide v-if="quickToggle && hasExcludedTypes">
                    <Swiper
                        v-show="quickToggle"
                        @swiper="onSwiper"
                        :loop="true"
                        :centered-slides="false"
                        :speed="1000"
                        :modules="[Navigation, Autoplay]"
                        :allow-slide-next="!spinning"
                        :allow-slide-prev="!spinning"
                        :allow-touch-move="!spinning"
                        class="mySwiper"
                        :direction="'horizontal'"
                        :slides-per-view="1"
                        :space-between="10"
                        :autoplay="{ delay: 2000, disableOnInteraction: false }">
                        <SwiperSlide v-for="(item, idx) in verticalItems" :key="idx">
                            <button @click="handleClick(item)" :aria-label="item.type" type="button" class="listed" :class="item.type">
                                <div v-if="item.type === 'lucky_spin' && isInHouseMerchant" class="relative">
                                    <img class="absolute z-10 w-full" :src="`${config.public.STATIC_ROOT}img/icons/${item.type}_frame.webp`" :alt="`${item.type}_frame`" />
                                    <img class="img_rotate_animation w-full" :src="`${config.public.STATIC_ROOT}img/icons/quick_${item.type}_new.webp?v=2`" :alt="`quick_${item.type}_new`" />
                                </div>
                                <img v-else class="w-full" :src="`${config.public.STATIC_ROOT}img/icons/quick_${item.type}.webp`" :alt="`quick_${item.type}`" />
                                <div v-if="item.type === 'angpow' && mainStore.angpau_isFixed" class="angpau_countdown">
                                    {{
                                        mainStore.angpau_isStarted
                                            ? $t("claim_now")
                                            : `${dashboardStore.angpau_hours >= 0 ? dashboardStore.angpau_hours : 0}H:${dashboardStore.angpau_minutes >= 0 ? dashboardStore.angpau_minutes : 0}M:${dashboardStore.angpau_seconds >= 0 ? dashboardStore.angpau_seconds : 0}S`
                                    }}
                                </div>
                            </button>
                        </SwiperSlide>
                    </Swiper>
                </SwiperSlide>
            </Swiper>
        </div>
    </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Navigation, Autoplay } from "swiper";
const config = useRuntimeConfig();
const { t } = useI18n();
const mainStore = useMainStore();
const menuStore = useMenuStore();
const dashboardStore = useDashboardStore();
const userStore = useUserStore();
const router = useRouter();
const localePath = useLocalePath();
const { isMobile } = useDevice();
const route = useRoute();
const campaignList = useState("campaignList", () => null);
const campaignListReady = useState("campaignListReady", () => false);
const isInHouseMerchant = computed(() => {
    if (
        [1].includes(config.public?.TMPL_TYPE) ||
        [
            "champ191",
            "aw8",
            "dis88",
            "finbet8",
            "gcwin99",
            "jolibet",
            "jw8",
            "wic11",
            "nepal",
            "siam66",
            "uea8",
            "wawin8",
            "ime88",
            "khalti88",
            "siam345",
            "siam369",
            "nex8v2",
            "papua",
            "jaya11",
            "sanuk99",
            "siam855asia",
            "mamubaji",
            "mw99"
        ].includes(config.public.MERCHANT)
    ) {
        return true;
    }
    return false;
});

const { isAllowedMerchantOrTmplTypeMiniGame } = useMiniGameEligibility();

const pageSlugMapping = {
    tournament: "leaderboard"
};

const menuList = computed(() => {
    if (!menuStore.ready || !dashboardStore.ready || !dashboardStore.data.currency) {
        return [];
    }
    var buildMenuList = [];

    const rewardData = menuStore.data?.reward?.[dashboardStore.data.currency];
    const today = new Date();

    const luckyWheel = rewardData?.active_event?.lucky_wheel;
    const luckyWheelSide = rewardData?.side?.indexOf("lucky_wheel") > -1;
    if (Array.isArray(luckyWheel) && luckyWheelSide && luckyWheel.length > 0) {
        const isActiveLuckyWheel = luckyWheel.some((event) => {
            const fromDate = new Date(event.date_from);
            const toDate = event.date_to ? new Date(event.date_to) : null;
            return fromDate <= today && (!toDate || today <= toDate);
        });

        if (isActiveLuckyWheel) {
            buildMenuList.push({
                message: t("lucky_spin"),
                type: "lucky_spin",
                url: `/lucky-spin`
            });
        }
    }

    const angpow = rewardData?.active_event?.angpow;
    if (Array.isArray(angpow) && angpow.length > 0 && dashboardStore.data?.angpow?.left_icon == 1) {
        const isActiveAngpow = angpow.some((event) => {
            const startDate = new Date(event.start_date);
            const endDate = event.end_date ? new Date(event.end_date) : null;
            return startDate <= today && (!endDate || today <= endDate);
        });

        if (isActiveAngpow) {
            buildMenuList.push({
                message: t("angpow"),
                type: "angpow",
                url: `/angpow`
            });
        }
    }

    if (mainStore.showCashBack) {
        buildMenuList.push({
            message: t("cashback"),
            type: "cashback"
        });
    }

    if (dashboardStore.data && userStore.loggedIn && mainStore.mysteryBoxAmount > 0) {
        buildMenuList.push({
            message: t("mystery_box"),
            type: "mystery_box"
        });
    }
    const campaign = rewardData?.side.includes("campaign");
    if (campaign && campaignListReady.value && Array.isArray(campaignList.value?.data) && campaignList.value.data.length > 0 && isAllowedMerchantOrTmplTypeMiniGame.value === true) {
        const campaignTypes = ["PLINKO", "SCRATCHER", "TREASURE_BOX"];
        const foundTypes = new Set();
        for (const campaignItem of campaignList.value.data) {
            if (campaignTypes.includes(campaignItem.mini_game_type)) {
                foundTypes.add(campaignItem.mini_game_type);
            }
        }
        for (const type of campaignTypes) {
            if (foundTypes.has(type)) {
                buildMenuList.push({
                    message: type,
                    type: "campaign",
                    miniGameType: type
                });
            }
        }
    }

    if (menuStore.data && menuStore.data.reward && menuStore.data.reward[dashboardStore.data.currency] && menuStore.data.reward[dashboardStore.data.currency]?.side) {
        for (let i = 0; i < menuStore.data.reward[dashboardStore.data.currency]?.side.length; i++) {
            var shortcut = menuStore.data.reward[dashboardStore.data.currency]?.side[i];
            let translateSlug = pageSlugMapping[shortcut];
            let displayName = translateSlug ? t(translateSlug) : shortcut;
            if (shortcut != "angpow" && shortcut != "lucky_wheel" && shortcut != "predictor" && shortcut != "campaign") {
                buildMenuList.push({
                    message: displayName,
                    type: translateSlug ? translateSlug : shortcut,
                    url: `/${translateSlug ? translateSlug.replace("_", "-") : shortcut}`
                });
            }

            if (shortcut == "predictor") {
                buildMenuList.push({
                    message: t("predictor"),
                    type: "predictor",
                    url: "/predictor/socccer"
                });
            }
        }
    }

    return buildMenuList;
});

const verticalItems = computed(() => {
    return menuList.value.filter((item) => ["lucky_spin", "angpow", "cashback", "mystery_box"].includes(item.type));
});

const excludedTypes = ["lucky_spin", "angpow", "cashback", "mystery_box"];

const filteredMenuList = computed(() => {
    if (quickToggle.value) {
        return menuList.value.filter((item) => !excludedTypes.includes(item.type));
    }
    return menuList.value;
});

const hasAllowedTypes = computed(() => {
    return menuList.value.some((item) => !excludedTypes.includes(item.type));
});

const hasExcludedTypes = computed(() => {
    return menuList.value.some((item) => excludedTypes.includes(item.type));
});

const swiperRef = ref(null);
const isBeginning = ref(true);
const isEnd = ref(false);
const spinning = ref(false);

const onSlideChange = () => {
    if (swiperRef.value) {
        isBeginning.value = swiperRef.value.isBeginning;
        isEnd.value = swiperRef.value.isEnd;

    }
};

const onSwiper = (swiper) => {
    swiperRef.value = swiper;
    isBeginning.value = swiper.isBeginning;
    isEnd.value = swiper.isEnd;
};

const goNext = () => swiperRef.value?.slideNext();
const goPrev = () => swiperRef.value?.slidePrev();

const showQuickLaunchLabel = "Show quick launch shortcuts";
const hideQuickLaunchLabel = "Hide quick launch shortcuts";

const quickLaunchBox = ref(true);
const swiperWrapperRef = ref(null);
const quickToggle = ref(false);

watch(quickToggle, async (val) => {
    await nextTick();

    if (val && swiperRef.value) {
        swiperRef.value.update();
    }
    keepInsideWindow();
});

const handleVipClick = () => {
    if (userStore.loggedIn) {
        navigateTo(localePath("/my-vip"));
    } else {
        navigateTo(localePath("/vip"));
    }
};

const handleSignIntaskClick = () => {
    if (userStore.loggedIn) {
        navigateTo(localePath("/sign-in-task"));
    } else {
        mainStore.loginModal = true;
    }
};

const getMiniGameImageUrl = (miniGameType) => {
    if (!miniGameType) return "";
    if (isAllowedMerchantOrTmplType.value === false) return "";
    // Map game types to their corresponding imported images
    const gameImageMap = {
        PLINKO: `/img/minigames/plinko2.webp?v=${config.public.VERSION}`,
        SCRATCHER: `/img/minigames/scratcher.webp?v=${config.public.VERSION}`,
        TREASURE_BOX: `/img/minigames/treasure_box.webp?v=${config.public.VERSION}`
    };

    const imageUrl = gameImageMap[miniGameType];
    if (!imageUrl) {
        console.warn(`No image mapping found for game type: ${miniGameType}`);
        return "";
    }

    return imageUrl;
};

const handleClick = (d) => {
    if (!hasAllowedTypes.value) {
        if (userStore.loggedIn) {
            mainStore.rewardsModal = true;
            localStorage.setItem("rewardActiveSlide", d.type);
        } else {
            mainStore.loginModal = true;
        }
    } else {
        if (!quickToggle.value) {
            quickToggle.value = true;
        } else if (d.type == "vip" && userStore.loggedIn) {
            navigateTo(localePath("/my-vip"));
        } else if (d.type == "vip") {
            navigateTo(localePath(d.url));
        } else if (d.type == "campaign") {
            if (userStore.loggedIn) {
                mainStore.rewardsModal = true;
                localStorage.setItem("rewardActiveSlide", d.type);
                localStorage.setItem("rewardCampaignMiniGameType", d.miniGameType);
            } else {
                mainStore.loginModal = true;
            }
        } else {
            if (userStore.loggedIn) {
                mainStore.rewardsModal = true;
                localStorage.setItem("rewardActiveSlide", d.type);
            } else {
                mainStore.loginModal = true;
            }
        }
    }
};

const handleLeaderboardClick = () => {
    if (isMobile) router.push(localePath("/leaderboard"));
    else mainStore.leaderboardModal = true;
};

const position = ref({ right: 12, bottom: 180 });
const isDragging = ref(false);
const offset = ref({ x: 0, y: 0 });

const toggleQuickLaunch = () => {
    quickToggle.value = !quickToggle.value;
    nextTick(() => keepInsideWindow());
};

const startDrag = (e) => {
    if (quickToggle.value) return;
    isDragging.value = true;
    const clientX = e.type.includes("touch") ? e.touches[0].clientX : e.clientX;
    const clientY = e.type.includes("touch") ? e.touches[0].clientY : e.clientY;
    offset.value = {
        x: window.innerWidth - clientX - position.value.right,
        y: window.innerHeight - clientY - position.value.bottom
    };
    document.addEventListener(e.type.includes("touch") ? "touchmove" : "mousemove", onDrag, { passive: false });
    document.addEventListener(e.type.includes("touch") ? "touchend" : "mouseup", stopDrag);
};

const onDrag = (e) => {
    if (!isDragging.value) return;
    const clientX = e.type.includes("touch") ? e.touches[0].clientX : e.clientX;
    const clientY = e.type.includes("touch") ? e.touches[0].clientY : e.clientY;
    position.value.right = window.innerWidth - clientX - offset.value.x;
    position.value.bottom = window.innerHeight - clientY - offset.value.y;
    keepInsideWindow();
    e.preventDefault();
};

const stopDrag = (e) => {
    isDragging.value = false;
    document.removeEventListener("mousemove", onDrag);
    document.removeEventListener("mouseup", stopDrag);
    document.removeEventListener("touchmove", onDrag);
    document.removeEventListener("touchend", stopDrag);
    localStorage.setItem("quickLaunchBoxPosition", JSON.stringify(position.value));
};

const keepInsideWindow = () => {
    if (!swiperWrapperRef.value) return;
    const box = swiperWrapperRef.value.parentElement;
    if (!box) return;
    const w = box.offsetWidth;
    const h = box.offsetHeight;
    const horizontalPadding = 15;
    const verticalPadding = 45;
    if (position.value.right < horizontalPadding) position.value.right = horizontalPadding;
    if (position.value.right > window.innerWidth - w - horizontalPadding) position.value.right = window.innerWidth - w - horizontalPadding;
    if (position.value.bottom < verticalPadding) position.value.bottom = verticalPadding;
    if (position.value.bottom > window.innerHeight - h - verticalPadding) position.value.bottom = window.innerHeight - h - verticalPadding;
    if (currency.value) {
        setPosition();
    }
};

const dashboardPosition = ref("bottom_right");

const currency = computed(() => {
    if (dashboardStore.ready && dashboardStore.data && dashboardStore.data.currency) {
        return dashboardStore.data.currency;
    }
    return "";
});
watch(
    () => currency.value,
    () => {
        setPosition();
    }
);

const displayStatus = ref(false);
const setPosition = () => {
    // FPT-4598
    if (["production", "staging"].includes(config.public.ENV) || config.public.MERCHANT === "mamubaji" || config.public.MERCHANT === "mw99") {
        dashboardPosition.value = "bottom_right";
        displayStatus.value = true;
        return;
    }

    if (dashboardStore?.ready && mainStore?.generalData?.data?.[dashboardStore.data.currency]) {
        dashboardPosition.value = mainStore.generalData?.data?.[dashboardStore.data.currency][0]?.general_display_setting[isMobile ? "mobile" : "web"].find(
            (x) => x.type === "quick_launch_display"
        ).display_position;
        displayStatus.value = mainStore.generalData?.data?.[dashboardStore.data.currency][0]?.general_display_setting[isMobile ? "mobile" : "web"].find(
            (x) => x.type === "quick_launch_display"
        ).display_status;
    }
    const box = document.querySelector(".quickLaunchBox-v2");
    const rect = box?.getBoundingClientRect();

    const w = rect?.width || 80;
    const h = rect?.height || 200;

    dashboardPosition.value = "middle_right";
    switch (dashboardPosition.value) {
        case "top_right":
            position.value.bottom = window.innerHeight - 180 - 60;
            if (quickToggle.value) {
                position.value.bottom = window.innerHeight - 440;
            }
            break;
        case "middle_right":
            position.value.bottom = window.innerHeight / 2 - h / 2;
            break;
        case "bottom_right":
            break;
        case "top_left":
            position.value.right = window.innerWidth - 6 - w;
            position.value.bottom = window.innerHeight - 180 - 60;
            if (quickToggle.value) {
                position.value.bottom = window.innerHeight - 440;
            }
            break;
        case "middle_left":
            position.value.right = window.innerWidth - 6 - w;
            position.value.bottom = window.innerHeight / 2 - h / 2;
            break;
        case "bottom_left":
            position.value.right = window.innerWidth - 6 - w;
            position.value.bottom = 180;
            break;
        default:
            break;
    }
};

onMounted(() => {
    const saved = localStorage.getItem("quickLaunchBoxPosition");
    if (saved) position.value = JSON.parse(saved);
    keepInsideWindow();
    setPosition(); // temp fix
    window.addEventListener("resize", keepInsideWindow);
});

onUnmounted(() => {
    window.removeEventListener("resize", keepInsideWindow);
});
</script>

<style scoped>
.quickLaunchBox-v2 {
    position: fixed;
    z-index: 101;
    user-select: none;
    touch-action: none;
    transition:
        right 0.5s ease,
        bottom 0.5s ease;
}

.quickLaunchBox-v2 .swiper-slide:last-child {
    margin-bottom: 0 !important;
}

.quickLaunchBox-v2.close {
    animation: growClose 1s ease-in-out forwards;
}

@keyframes growClose {
    0% {
        transform: scale(1);
        opacity: 1;
    }
    100% {
        transform: scale(0);
        opacity: 0;
    }
}

.quickLaunchBox-v2.horizontal {
    width: 70px;
    animation: growDown 1s ease-in-out forwards;
}

@keyframes growDown {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.quickLaunchBox-v2 .listed {
    width: 48px;
}

.quickLaunchBox-v2 .listed img {
    object-fit: fill;
}

.quickLaunchBox-v2.vertical {
    text-align: center;
    touch-action: none !important;
    animation: growUp 1s ease-in-out forwards;
    transform-origin: bottom center;
}
.quickLaunchBox-v2.vertical.top {
    text-align: center;
    touch-action: none !important;
    animation: growUp 1s ease-in-out forwards;
    transform-origin: top center;
}

@keyframes growUp {
    0% {
        transform: scaleY(0);
        opacity: 0;
    }
    80% {
        transform: scaleY(1.05);
        opacity: 1;
    }
    100% {
        transform: scaleY(1);
    }
}

.quickLaunchBox-v2.vertical .swiper-container-wrapper {
    height: auto;
    transition: max-height 0.3s ease;
    width: 75px;
    margin: auto;
}

.mobile .quickLaunchBox-v2.vertical .swiper-container-wrapper {
    width: 60px;
}

.quickLaunchBox-v2.vertical .quick-toggle-nav {
    left: 50% !important;
    transform: translateX(-50%);
    z-index: 999;
}

.quickLaunchBox-v2.vertical .quick-nav-prev {
    top: -10px;
}

.quickLaunchBox-v2.vertical .quick-nav-next {
    bottom: -10px;
}

.animate-event {
    display: inline-block;
    animation: tada 1.5s ease-in-out infinite;
}

.listed.leaderboard {
    display: inline-block;
    animation: heartbeat 1.1s infinite;
    animation-timing-function: ease-in-out;
}
@keyframes heartbeat {
    0% {
        transform: scale(1);
    }
    14% {
        transform: scale(1.1);
    }
    28% {
        transform: scale(1);
    }
    42% {
        transform: scale(1.1);
    }
    70% {
        transform: scale(1);
    }
    100% {
        transform: scale(1);
    }
}

.listed.vip {
    display: inline-block;
    animation: pulse 1.3s infinite;
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}

.listed.daily_mission {
    position: relative;
    animation: swing 0.8s ease-in-out infinite alternate;
    transform-origin: center -80px;
}

.listed.angpow {
    position: relative;
    animation: wobble 1s ease infinite;
    transform-origin: center -80px;
}

@keyframes swing {
    from {
        transform: rotate(-2deg);
    }
    to {
        transform: rotate(2deg);
    }
}

@keyframes wobble {
    0%,
    100% {
        -webkit-transform: translateX(0%);
        transform: translateX(0%);
        -webkit-transform-origin: 50% 50%;
        transform-origin: 50% 50%;
    }

    15% {
        -webkit-transform: translateX(-8px) rotate(-10deg);
        transform: translateX(-8px) rotate(-10deg);
    }

    30% {
        -webkit-transform: translateX(calc(8px / 2)) rotate(10deg);
        transform: translateX(calc(8px / 2)) rotate(10deg);
    }

    45% {
        -webkit-transform: translateX(calc(-8px / 2)) rotate(calc(-10deg / 1.8));
        transform: translateX(calc(-8px / 2)) rotate(calc(-10deg / 1.8));
    }

    60% {
        -webkit-transform: translateX(calc(8px / 3.3)) rotate(calc(10deg / 3));
        transform: translateX(calc(8px / 3.3)) rotate(calc(10deg / 3));
    }

    75% {
        -webkit-transform: translateX(calc(-8px / 5.5)) rotate(calc(-10deg / 5));
        transform: translateX(calc(-8px / 5.5)) rotate(calc(-10deg / 5));
    }
}

.angpau_countdown {
    font-size: 8px;
}

.listed.cashback {
    animation: wobble 1.1s ease-in-out infinite;
    transform-origin: center;
}

@keyframes wobble {
    0% {
        transform: rotate(0deg);
    }
    12.5% {
        transform: rotate(5deg);
    }
    25% {
        transform: rotate(-5deg);
    }
    37.5% {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(5deg);
    }
    62.5% {
        transform: rotate(-5deg);
    }
    75% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(0deg);
    }
}
/* Responsive */
@media (max-width: 767px) {
    .btn-quick-box {
        position: relative;
        left: -10px;
        top: 0px;
    }
    .btn-quick-box::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 48px;
        height: 48px;
        transform: translate(-50%, -50%);
    }

    .btn-quick-center {
        position: relative;
        top: 0px;
        /* position: relative; */
    }
    .btn-quick-center::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 48px;
        height: 48px;
        transform: translate(-50%, -50%);
    }
}

.img_rotate_animation {
    display: inline-block;
    animation: rotateCycle 3s ease-in-out infinite;
    transform-origin: center;
}

@keyframes rotateCycle {
    0% {
        transform: rotate(0deg);
        animation-timing-function: ease-in;
    }
    30% {
        transform: rotate(200deg);
        animation-timing-function: ease-out;
    }
    90% {
        transform: rotate(720deg);
        animation-timing-function: ease-out;
    }
    100% {
        transform: rotate(720deg);
        animation-timing-function: ease-out;
    }
}
</style>